import React from 'react';
import Slider from 'react-slick';

import Img from '../../../components/Img';

import styles from './powerPerksPage.scss';

const slides = [
    {
        name: 'Kevin K',
        title: '',
        quote: 'Power is a great way to find more competitive play. With 2 decimals, I have a better feel for how close the match will be.',
        imgUrl: '/img/v3/graphics/testimonials/kevin.png',
    },
    {
        name: 'Chris Y',
        title: '',
        quote: 'As a coach, I like the results analysis and three-month trending that Power gives to my players.',
        imgUrl: '/img/v3/graphics/testimonials/chris.png',
    },
];

const Testimonials = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
    };
    return (
        <div className={styles.testimonial} style={{ color: 'white' }}>
            <Slider {...settings}>
                {slides.map(slide => {
                    return (
                        <div className={styles.wrapper}>
                            <div className={styles.background}>
                                <div className={styles.inner}>
                                    <div className={styles.image}>
                                        <Img src={slide.imgUrl} />
                                    </div>
                                    <div className={styles.quoteMark}>
                                        “
                                    </div>
                                    <div className={styles.quote}>
                                        {slide.quote}
                                    </div>
                                    <div className={styles.title}>
                                        {slide.title}
                                    </div>
                                </div>
                                <div className={styles.name}>
                                    {slide.name}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
};

export default Testimonials;
